'use strict';

var App = require('app');

var API = {
    hasOwnSchema: function (id) {
        var defer = $.Deferred();

        App.ajax({
            url: '/api/v1/devices/' + id + '/scheme/db' + id + '.svg',
            type: 'GET',
            async: true,

            success: function () {
                defer.resolve(true);
            },
            error: function () {
                defer.resolve(false);
            },
        });

        return defer.promise();
    },

    getSchemaJSON: function (id) {
        var defer = $.Deferred();

        App.ajax({
            url: '/api/v1/devices/' + id + '/scheme/db' + id + '.json',
            type: 'GET',
            async: true,

            success: function (file) {
                defer.resolve(file);
            },
            error: function () {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('schema:has_own', function (id) {
    return API.hasOwnSchema(id);
});

App.reqres.setHandler('schema:additional', function (id) {
    return API.getSchemaJSON(id);
});
